module.exports = __webpack_public_path__ + "static/media/logo.4e403888.svg";